module.exports = __webpack_public_path__ + "static/media/win.64d1afd0.svg";